// frontend/src/config.js
export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://197.156.76.122/api";
